import { type FC, type JSX, cloneElement, useMemo } from 'react';

import { WrapElementsSpacer } from 'shared/components/WrapElementsSpacer';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { SeriaPlusLabel } from './internal/components/SeriaPlusLabel';
import { type BadgesTypes } from './types';

/**
 * @description Данная конструкция нужна для того, что бы логировать случаи, когда бекенд присылает лейбл, но фронтенд
 *   о нём не знает
 */
const unknownLoggedLabels = new Set<BadgesTypes>();

type BadgesProps = {
  badges: BadgesTypes[];
};

export const Badges: FC<BadgesProps> = ({ badges }) => {
  const { logger } = useApplicationContext();

  const badgesViews = useMemo(() => {
    return badges.reduce((accumulator, badge) => {
      const labelView = ((): JSX.Element | undefined => {
        switch (badge) {
          case 'seriaPlus':
            return <SeriaPlusLabel />;
        }
      })();

      if (labelView) {
        accumulator.push(cloneElement(labelView, { key: badge }));
      } else if (!unknownLoggedLabels.has(badge)) {
        logger.warning(
          `Не реализован бейдж с типом: ${badge} или на оборот удалить его так как визуала под этот тип нет`,
          { domain: 'src/shared/components/Carousel/internal/components/Badges/Badges.tsx' },
        );

        unknownLoggedLabels.add(badge);
      }

      return accumulator;
    }, Array.of<JSX.Element>());
  }, [badges, logger]);

  return (
    <WrapElementsSpacer
      containerTestId="carousel-badges.container"
      horizontalSpace={4}
      itemTestId="carousel-badges.label"
      verticalSpace={4}
    >
      {badgesViews}
    </WrapElementsSpacer>
  );
};
